/** @module                 React */

import { useState }         from "react";

/** @module                 Router */

import { useNavigate }      from "react-router-dom";

/** @module                 Apollo */

import { useMutation }      from "@apollo/client";

import { DELETE_APPOINTMENT } from "../../Mutations/Montage";

const 

/** 
 * 
 * @returns useDeleteAppointment hook for deleting existing appointment
 * 
 */

useDeleteAppointment = () => { const 

    /** @hooks */

    navigate                    = useNavigate (),

    [ loading,  setLoading  ]   = useState ( false ),

    [ errors,   setErrors   ]   = useState ( false ),

    /** @mutations */

    [ DeleteAppointment ] = useMutation ( DELETE_APPOINTMENT, {

        /** @event onComplete */

        onCompleted ( data ) {

            setLoading ( false );

            return navigate ( `/app/montage` );

        },

        /** @event onError */

        onError ( err ) { setLoading ( false ); setErrors ( true ); }

    } ),

    /** 
     * 
     * @param { Number } id
     * 
     * @returns delete appointment action
     * 
     */

    deleteAppointment = ( id ) => {

        /** @validation */

        setErrors ( false ); setLoading ( true );

        if ( ! id ) {

            setErrors   ( true  );

            setLoading  ( false );

            return;

        };

        /** @mutation */

        DeleteAppointment ( { variables: { id } } );

    }

    /** @returns */

    return { deleteAppointment, loading, errors }

}

/** @exports useDeleteAppointment */

export default useDeleteAppointment;